import { render, staticRenderFns } from "./MaintenancePlan.vue?vue&type=template&id=afcd3738"
import script from "./MaintenancePlan.vue?vue&type=script&lang=js"
export * from "./MaintenancePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports